import { Button, Input, makeStyles, Text } from '@rneui/themed'
import * as Clipboard from 'expo-clipboard'
import { t } from 'app/i18l'
import React, { useEffect, useState } from 'react'
import { View  } from 'react-native'

import { SafeAreaView } from 'react-native-safe-area-context'
interface Props {
  onSubmit: (phoneNumber: string) => void
  userName: string
}

export function AddMobileNumberView({ onSubmit, userName }: Props) {
  const [text, setText] = useState('')

  const styles = useStyles()

  const fetchCopiedText = async () => {
    const copiedText = await Clipboard.getStringAsync()
    const regex = /^\d+$/
    if (regex.test(copiedText)) {
      if (copiedText.length === 10) {
        setText(copiedText)
      } else if (copiedText.length === 11) {
        setText(copiedText.slice(1))
      }
    }
  }

  useEffect(() => {
    fetchCopiedText().catch(() => null)
  }, [])

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.container}>
      <View style={styles.card}>
        <Text>{t('addMobileNumberText').replace('{USER_NAME}', userName)}</Text>
        <View style={styles.row}>
          <Text style={styles.phoneCode}>+1</Text>
          <Input
            style={styles.input}
            value={text}
            placeholder={t('enterMobileNumberHere')}
            onChangeText={setText}
            autoFocus
            keyboardType="phone-pad"
          />
        </View>
        <Button
          title="Submit"
          onPress={() => onSubmit(text)}
          disabled={!isValidPhoneNumber(text)}
        />
      </View>
    </SafeAreaView>
  )
}

function isValidPhoneNumber(number: string) {
  if (!number || number.length !== 10) {
    return false
  } else {
    return true
  }
}

const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
    backgroundColor: theme.colors?.grey5,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 40,
    marginVertical: 10,
  },
  phoneCode: {
    paddingRight: 5,
  },
  input: {
    flex: 1,
    paddingHorizontal: 5,
    paddingVertical: 10,
    borderWidth: 0.5,
    borderColor: theme.colors?.black,
    color: theme.colors?.black,
  },
  card: {
    justifyContent: 'center',
    backgroundColor: theme.colors?.white,
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.29,
    shadowRadius: 4.65,
    padding: 10,
  },
}))
